if (!window.Maximize.loadedScript.includes('article.js')) {
    window.Maximize.loadedScript.push('article.js');
  
    requestAnimationFrame(() => {
      document.addEventListener('alpine:init', () => {
        Alpine.data('xArticle', () => ({
          show: false,
          showInTab: false,
          init() {
            this._tocFrame = null;
            this._tocLockUntil = 0;

            this._tocPaint = (item) => {
              const menu = item.closest('.menu-article');
              const list = menu?.querySelector('.list-menu-article');
              if (!list) return;

              menu.querySelectorAll('.item-menu-article').forEach((entry) => {
                const active = entry === item;

                if (entry.classList.contains('active') !== active) {
                  entry.classList.toggle('active', active);
                }

                if (active) {
                  entry.setAttribute('aria-current', 'location');
                } else {
                  entry.removeAttribute('aria-current');
                }
              });

              if (!list.getClientRects().length) return;

              const visibleItems = Array.from(
                menu.querySelectorAll('.item-menu-article')
              ).filter((entry) => (
                entry.getClientRects().length &&
                getComputedStyle(entry).display !== 'none'
              ));

              if (!visibleItems.length) return;

              const rect = list.getBoundingClientRect();
              const topOf = (entry) => (
                entry.getBoundingClientRect().top -
                rect.top -
                list.clientTop +
                list.scrollTop
              );

              const first = visibleItems[0];
              const last = visibleItems[visibleItems.length - 1];
              const trackTop = topOf(first);
              const trackHeight =
                topOf(last) +
                last.getBoundingClientRect().height -
                trackTop;

              // 停用旧的背景画线方式。
              list.style.setProperty('background-image', 'none', 'important');

              const host = list.parentElement;
              host.style.setProperty('position', 'relative');

              let track = host.querySelector('[data-toc-track]');
              let marker = host.querySelector('[data-toc-marker]');

              if (!track) {
                track = document.createElement('span');
                track.setAttribute('data-toc-track', '');
                track.setAttribute('aria-hidden', 'true');
                host.appendChild(track);
              }

              if (!marker) {
                marker = document.createElement('span');
                marker.setAttribute('data-toc-marker', '');
                marker.setAttribute('aria-hidden', 'true');
                host.appendChild(marker);
              }

              const hostRect = host.getBoundingClientRect();
              const firstRect = first.getBoundingClientRect();
              const lastRect = last.getBoundingClientRect();
              const itemRect = item.getBoundingClientRect();

              const hostTop =
                hostRect.top + host.clientTop - host.scrollTop;
              const hostLeft =
                hostRect.left + host.clientLeft - host.scrollLeft;

              const rtl = getComputedStyle(list).direction === 'rtl';
              const x = rtl
                ? rect.right - hostLeft - 3
                : rect.left - hostLeft;

              const baseStyles = {
                display: 'block',
                position: 'absolute',
                margin: '0',
                padding: '0',
                border: '0',
                'pointer-events': 'none',
                'box-sizing': 'border-box',
                opacity: '1',
                visibility: 'visible',
                transition: 'none'
              };

              [track, marker].forEach((element) => {
                Object.entries(baseStyles).forEach(([key, value]) => {
                  element.style.setProperty(key, value, 'important');
                });
              });

              track.style.setProperty('left', `${x + 1}px`, 'important');
              track.style.setProperty(
                'top',
                `${firstRect.top - hostTop}px`,
                'important'
              );
              track.style.setProperty(
                'height',
                `${Math.max(0, lastRect.bottom - firstRect.top)}px`,
                'important'
              );
              track.style.setProperty('width', '0.5px', 'important');
              track.style.setProperty('background', '#d6d6d6', 'important');
              track.style.setProperty('z-index', '2', 'important');

              marker.style.setProperty('left', `${x + 0.25}px`, 'important');
              marker.style.setProperty(
                'top',
                `${itemRect.top - hostTop}px`,
                'important'
              );
              marker.style.setProperty(
                'height',
                `${itemRect.height}px`,
                'important'
              );
              marker.style.setProperty('width', '2px', 'important');
              marker.style.setProperty(
                'background',
                '#C72024',
                'important'
              );
              marker.style.setProperty('z-index', '3', 'important');
            };

            this._tocRelease = () => {
              clearTimeout(this._tocUnlockTimer);
              clearTimeout(this._tocSafetyTimer);
              this._tocLockUntil = 0;
              this._tocSchedule();
            };

            this._tocScroll = () => {
              this._tocSchedule();

              if (this._tocLockUntil > Date.now()) {
                clearTimeout(this._tocUnlockTimer);
                this._tocUnlockTimer = setTimeout(this._tocRelease, 180);
              }
            };

            this._tocUpdate = () => {
              this._tocFrame = null;

              if (Date.now() < this._tocLockUntil) return;

              const content = document.querySelector(
                '.main-article__text .page__body'
              );
              const menu = document.querySelector('.menu-article');
              if (!content || !menu) return;

              const headings = Array.from(
                content.querySelectorAll('h2, h3, h4')
              );
              const items = Array.from(
                menu.querySelectorAll('.item-menu-article')
              );

              const visiblePairs = headings
                .map((heading, index) => ({
                  heading,
                  item: items[index]
                }))
                .filter(({ item }) => {
                  if (!item) return false;

                  let node = item;

                  while (node && node !== menu) {
                    if (
                      node.tagName === 'UL' &&
                      !node.classList.contains('list-menu-article') &&
                      getComputedStyle(node).display === 'none'
                    ) {
                      return false;
                    }

                    node = node.parentElement;
                  }

                  return true;
                });

              if (!visiblePairs.length) return;

              const offset = parseFloat(
                getComputedStyle(content).getPropertyValue(
                  '--toc-scroll-offset'
                )
              ) || 128;

              let current = visiblePairs[0];

              visiblePairs.forEach((pair) => {
                if (
                  pair.heading.getBoundingClientRect().top <= offset + 8
                ) {
                  current = pair;
                }
              });

              const atPageBottom =
                window.scrollY + window.innerHeight >=
                document.documentElement.scrollHeight - 4;

              if (atPageBottom) {
                current = visiblePairs[visiblePairs.length - 1];
              }

              this._tocPaint(current.item);
            };

            this._tocSchedule = () => {
              if (this._tocFrame) return;

              this._tocFrame = requestAnimationFrame(this._tocUpdate);
            };

            window.addEventListener('scroll', this._tocScroll, {
              passive: true
            });
            window.addEventListener('resize', this._tocSchedule);
            window.addEventListener('scrollend', this._tocRelease);

            if (window.ResizeObserver) {
              this._tocResizeObserver = new ResizeObserver(() => {
                const active = document.querySelector(
                  '.menu-article .item-menu-article.active'
                );

                if (active) this._tocPaint(active);
                this._tocSchedule();
              });

              [
                document.querySelector('.menu-article'),
                document.querySelector('.main-article__text .page__body')
              ].forEach((element) => {
                if (element) this._tocResizeObserver.observe(element);
              });
            }

            this.$nextTick(() => this._tocSchedule());
          },

          destroy() {
            window.removeEventListener('scroll', this._tocScroll);
            window.removeEventListener('resize', this._tocSchedule);
            window.removeEventListener('scrollend', this._tocRelease);

            this._tocResizeObserver?.disconnect();
            cancelAnimationFrame(this._tocFrame);
            clearTimeout(this._tocUnlockTimer);
            clearTimeout(this._tocSafetyTimer);
          },
          loadData(list_style) {
            const load = document.querySelector('.load-curr');
            const loadBar = document.querySelector('.load-bar');
            const element = this.$refs.content;
            if (element) {
              document.addEventListener('scroll', () => {
                const elementTop = element.offsetTop;
                const elementHeight = element.offsetHeight;
                const windowHeight = window.innerHeight;
                const scrollPosition = window.scrollY + windowHeight;

                let scrollPercent;

                if (scrollPosition < elementTop) {
                  scrollPercent = 0;
                  if(loadBar) loadBar.classList.remove("active-bar")
                } else if (scrollPosition > elementTop + elementHeight) {
                  scrollPercent = 100;
                } else {
                  if(loadBar) loadBar.classList.add("active-bar")
                  scrollPercent = ((scrollPosition - elementTop) / elementHeight) * 100;
                }
                if (load) load.style.width = scrollPercent.toFixed(2) + `%`
              })
            }
            const heading2 = document.querySelector('.main-article__text .page__body').querySelectorAll('h2, h3, h4');
            if (heading2.length > 1) {
              let htmlContent = "";
              heading2.forEach((item, index) => {
                if (item.tagName === 'H2') {
                  htmlContent += "<li class='toc:m-0 toc:mt-1.5 item-menu-article w-full cursor-pointer' tabindex='0' @keydown.enter='scrollTop($el," + index + ")' tabindex='0' @keydown.enter='scrollTop($el," + index + ")' @click='scrollTop($el," + index + ")' >" + item.textContent + "</li>";
                }
                if (item.tagName === 'H3') {
                  if (heading2[index-1] && heading2[index-1].tagName === 'H2') {
                    if (index !== heading2.length-1 && heading2[index+1].tagName !== 'H2') {
                      htmlContent += list_style === 'bullet' ? "<ul class='toc:m-0 toc:pl-5'><li class='toc:m-0 toc:mt-1.5 item-menu-article w-full cursor-pointer' tabindex='0' @keydown.enter='scrollTop($el," + index + ")' @click='scrollTop($el," + index + ")' >" + item.textContent + "</li>" 
                      : "<ul class='toc:m-0 toc:pl-4'><li class='toc:m-0 toc:mt-1.5 item-menu-article w-full cursor-pointer' tabindex='0' @keydown.enter='scrollTop($el," + index + ")' @click='scrollTop($el," + index + ")' >" + item.textContent + "</li>"
                    } else {
                      htmlContent += list_style === 'bullet' ? "<ul class='toc:m-0 toc:pl-5'><li class='toc:m-0 toc:mt-1.5 item-menu-article w-full cursor-pointer' tabindex='0' @keydown.enter='scrollTop($el," + index + ")' @click='scrollTop($el," + index + ")' >" + item.textContent + "</li></ul>"
                      : "<ul class='toc:m-0 toc:pl-4'><li class='toc:m-0 toc:mt-1.5 item-menu-article w-full cursor-pointer' tabindex='0' @keydown.enter='scrollTop($el," + index + ")' @click='scrollTop($el," + index + ")' >" + item.textContent + "</li></ul>"
                    }
                  } else {
                    if (index !== heading2.length-1 && heading2[index+1].tagName !== 'H2') {
                      htmlContent += "<li class='toc:m-0 toc:mt-1.5 item-menu-article w-full cursor-pointer' tabindex='0' @keydown.enter='scrollTop($el," + index + ")' @click='scrollTop($el," + index + ")' >" + item.textContent + "</li>"
                    } else {
                      htmlContent += "<li class='toc:m-0 toc:mt-1.5 item-menu-article w-full cursor-pointer' tabindex='0' @keydown.enter='scrollTop($el," + index + ")' @click='scrollTop($el," + index + ")' >" + item.textContent + "</li></ul>"
                    }
                  }      
                }
                if (item.tagName === 'H4') {
                  if (heading2[index-1] && heading2[index-1].tagName !== 'H4') {
                    if (index !== heading2.length-1 && heading2[index+1].tagName === 'H4') {
                      htmlContent += list_style === 'bullet' ? "<ul class='toc:m-0 toc:pl-5'><li class='toc:m-0 toc:mt-1.5 item-menu-article w-full cursor-pointer' tabindex='0' @keydown.enter='scrollTop($el," + index + ")' @click='scrollTop($el," + index + ")' >" + item.textContent + "</li>"
                      : "<ul class='toc:m-0 toc:pl-6'><li class='toc:m-0 toc:mt-1.5 item-menu-article w-full cursor-pointer' tabindex='0' @keydown.enter='scrollTop($el," + index + ")' @click='scrollTop($el," + index + ")' >" + item.textContent + "</li>"
                    } else if (index !== heading2.length-1 && heading2[index+1].tagName === 'H3') {
                      htmlContent += list_style === 'bullet' ? "<ul class='toc:m-0 toc:pl-5'><li class='toc:m-0 toc:mt-1.5 item-menu-article w-full cursor-pointer' tabindex='0' @keydown.enter='scrollTop($el," + index + ")' @click='scrollTop($el," + index + ")' >" + item.textContent + "</li></ul>"
                      : "<ul class='toc:m-0 toc:pl-6'><li class='toc:m-0 toc:mt-1.5 item-menu-article w-full cursor-pointer' tabindex='0' @keydown.enter='scrollTop($el," + index + ")' @click='scrollTop($el," + index + ")' >" + item.textContent + "</li></ul>"
                    } else {
                      htmlContent += list_style === 'bullet' ? "<ul class='toc:m-0 toc:pl-5'><li class='toc:m-0 toc:mt-1.5 item-menu-article w-full cursor-pointer' tabindex='0' @keydown.enter='scrollTop($el," + index + ")' @click='scrollTop($el," + index + ")' >" + item.textContent + "</li></ul></ul>"
                      : "<ul class='toc:m-0 toc:pl-6'><li class='toc:m-0 toc:mt-1.5 item-menu-article w-full cursor-pointer' tabindex='0' @keydown.enter='scrollTop($el," + index + ")' @click='scrollTop($el," + index + ")' >" + item.textContent + "</li></ul></ul>"
                    }
                  } else {
                    if (index !== heading2.length-1 && heading2[index+1].tagName === 'H4') {
                      htmlContent += "<li class='toc:m-0 toc:mt-1.5 item-menu-article w-full cursor-pointer' tabindex='0' @keydown.enter='scrollTop($el," + index + ")' @click='scrollTop($el," + index + ")' >" + item.textContent + "</li>"
                    } else if (index !== heading2.length-1 && heading2[index+1].tagName === 'H3') {
                      htmlContent += "<li class='toc:m-0 toc:mt-1.5 item-menu-article w-full cursor-pointer' tabindex='0' @keydown.enter='scrollTop($el," + index + ")' @click='scrollTop($el," + index + ")' >" + item.textContent + "</li></ul>"
                    } else {
                      htmlContent += "<li class='toc:m-0 toc:mt-1.5 item-menu-article w-full cursor-pointer' tabindex='0' @keydown.enter='scrollTop($el," + index + ")' @click='scrollTop($el," + index + ")' >" + item.textContent + "</li></ul></ul>"
                    }
                  }
                }
              })
              document.querySelector('.list-menu-article').innerHTML += htmlContent;
            }
          },
          scrollTop(el, index) {
            const content = document.querySelector(
              '.main-article__text .page__body'
            );
            const menu = el.closest('.menu-article');
            if (!content || !menu) return;

            const target = content.querySelectorAll(
              'h2, h3, h4'
            )[index];

            if (!target) return;

            this._tocPaint(el);

            this._tocLockUntil = Infinity;
            clearTimeout(this._tocUnlockTimer);
            clearTimeout(this._tocSafetyTimer);

            const offset = parseFloat(
              getComputedStyle(content).getPropertyValue(
                '--toc-scroll-offset'
              )
            ) || 128;

            const reduceMotion = window.matchMedia(
              '(prefers-reduced-motion: reduce)'
            ).matches;

            window.scrollTo({
              top: Math.max(
                0,
                window.scrollY +
                  target.getBoundingClientRect().top -
                  offset
              ),
              behavior: reduceMotion ? 'auto' : 'smooth'
            });

            this._tocUnlockTimer = setTimeout(this._tocRelease, 300);
            this._tocSafetyTimer = setTimeout(this._tocRelease, 4000);
          },
          setPositionSideBar() {
            let sideBarElement = document.querySelector('#side-bar-template');
            if (sideBarElement) {
              if (sideBarElement.querySelector('.side-bar__load-bar .load-bar')) {
                document.querySelector('.main-article__load-bar').appendChild(sideBarElement.querySelector('.side-bar__load-bar .load-bar'));
              }
            }
          }
        }));
      })
    });
  }